<template>
    <el-dialog  :title="`${isEdit ? '编辑':'新建'}职位`" :visible.sync="showDialog" :close-on-click-modal="false" :close-on-press-escape="false">
        <component :is="'el-form'" ref="ruleForm" :rules="rules" :key="preventKey" :model="ruleForm"
                   class="form-col"
                   label-width="140px" style="margin-left: -35px;">
            <div class="col-2 clearfix">
                <el-form-item label="职位名称" prop="name">
                    <el-input v-model.trim="ruleForm.name" :maxlength="50" :disabled="ruleForm.state==1"
                              placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="工作地点" prop="cityIds">
                    <el-select multiple v-model="ruleForm.cityIds" placeholder="请选择">
                        <el-option v-for="(item, index) in selectMap.WB_POSITION_CITY"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="办公地点" prop="workPlace">
                    <el-input
                        v-model.trim="ruleForm.workPlace"
                        :maxlength="20"
                        placeholder="请输入"
                    />
                </el-form-item>
                <el-form-item label="岗位序列" prop="sequenceMain" required>
                    <el-select
                        v-model="ruleForm.sequenceMain"
                        placeholder="请选择"
                        filterable
                        clearable
                        @change="ruleForm.sequenceSub = ''"
                    >
                        <el-option
                            v-for="item in mainSeqList"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="岗位子序列" prop="sequenceSub" required>
                    <el-select
                        v-model="ruleForm.sequenceSub"
                        placeholder="请选择"
                        clearable
                    >
                        <el-option
                            v-for="item in subSeqList"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="招聘部门" prop="deptCode">
                    <el-select v-model="ruleForm.deptCode"
                               filterable
                               remote
                               placeholder="请输入关键词"
                               :clearable="true"
                               :remote-method="remoteMethod">
                        <el-option v-for="(item, index) in deptArr"
                                   :key="item.deptCode"
                                   :label="item.name"
                                   :value="item.deptCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评分标准" v-if="needIds.includes(projectId)" prop="scoreType">
                    <el-select v-model="ruleForm.scoreType" placeholder="请选择" :clearable="true">
                        <!-- <el-option label="无" value=""></el-option> -->
                        <el-option v-for="(item, index) in scoreTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="招聘人数" prop="recruitCount"> 
                    <el-input v-model.trim="ruleForm.recruitCount" :maxlength="5"
                              placeholder="请输入（0或者不填表示不限）"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-select v-model="ruleForm.state" placeholder="请选择" :disabled="isEdit" :clearable="true">
                        <el-option v-for="(state, key) in selectMap.WB_POSITION_STATE" :key="key"
                                   v-if="checkStateOption(state)"
                                   :label="state.text" :value="state.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="招聘范围" prop="property">
                    <el-select v-model="ruleForm.property" placeholder="请选择" :clearable="true">
                        <el-option v-for="(state, key) in selectMap.WB_PROPERTY_TYPE" :key="key"
                                   :label="state.text" :value="state.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否门户展示" prop="showInDesk">
                    <el-radio-group v-model="ruleForm.showInDesk">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="定薪规则" v-if="hasSalary" prop="paymentId">
                    <el-select v-model="ruleForm.paymentId" placeholder="请选择" :clearable="true">
                        <el-option v-for="(item, key) in paymentRuleList" :key="key"
                                   :label="item.name" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否推送供应商" prop="toSupplier">
                    <el-radio-group v-model="ruleForm.toSupplier">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="内推职位" prop="recommendable">
                    <el-radio-group v-model="ruleForm.recommendable">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="招聘HR" prop="mark">
                    <el-input v-model.trim="ruleForm.mark" :maxlength="50"
                              placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="供应商选择" v-if="String(ruleForm.toSupplier) === '1'" prop="linkmanAndSupplier" required="">
                    <el-select
                        :value="ruleForm.linkmanAndSupplier"
                        filterable
                        multiple
                        placeholder="请选择"
                        :no-data-text="filterEmpty ? '无匹配数据' : '无数据'"
                        :clearable="true"
                        :filter-method="selectFilter"
                        popper-class="supplier-select-popover"
                        @input="handleOptionChange"
                    >
                        <template v-if="!filterEmpty">
                            <div
                                v-for="supplier in suppliers"
                                v-show="supplier.users.length"
                                :key="supplier.compId"
                            >
                                <el-option
                                    v-if="supplier.users.filter(u => u.visible).length"
                                    class="supplier-checkbox"
                                    :label="supplier.compName"
                                    :value="supplier.compId"
                                >
                                    {{ '所属公司：'+ supplier.compName }}
                                </el-option>
                                <el-option
                                        v-for="item in supplier.users"
                                        v-show="item.visible"
                                        :key="item.id"
                                        :label="item.name"
                                        :disabled="ruleForm.linkmanAndSupplier.includes(supplier.compId)"
                                        :value="String(item.id)">
                                    <span style="float: left">{{ item.name }}</span>
                                    <span style="float: right; color: #8492a6; margin-right:25px;">{{ item.company }}</span>
                                </el-option>
                            </div>
                        </template>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item label="在线时间:" prop="onlineDate" class="width-longer">
                <div class="f-edit">
                    <el-date-picker type="date" placeholder="上线时间"
                                    ref="startDate"
                                    :editable="false"
                                    v-model="ruleForm.onlineDate" @change="startDateChange"
                                    :picker-options="startDateOption"></el-date-picker>
                    至
                    <el-form-item prop="offlineDate" style="display: inline-block;">
                        <el-date-picker type="date" placeholder="下线时间"
                                        ref="endDate"
                                        :editable="false"
                                        v-model="ruleForm.offlineDate" @change="endDateChange"
                                        :picker-options="endDateOption"></el-date-picker>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item label="工作性质" prop="workType" required>
                <el-input v-model.trim="ruleForm.workType" :maxlength="50" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="岗位建议方向">
                <el-input v-model.trim="ruleForm.advise" :maxlength="50" placeholder="请输入"></el-input>
                <p style="color: #b1b1b1;font-size: 12px;line-height: 24px;">若存在多个方向，请用顿号‘、’隔开，例如：‘开发、设计、测试’，若不填写，则面试官填写面试评价时无须选择</p>
            </el-form-item>
            <el-form-item label="职位描述" prop="description">
                <el-input v-model="ruleForm.description" type="textarea" :autosize="{ minRows: 3, maxRows: 6}"
                          resize="none" :maxlength="1000" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="职位要求" prop="requirement">
                <el-input v-model="ruleForm.requirement" type="textarea" :autosize="{ minRows: 3, maxRows: 6}"
                          resize="none" :maxlength="1000" placeholder="请输入"></el-input>
            </el-form-item>
        </component>
        <div slot="footer">
            <el-button @click="submitForm('ruleForm', true)" :disabled="submitDisabled">保存</el-button>
            <el-button @click="submitForm('ruleForm', false)" type="primary" v-if="!isEdit" :disabled="submitDisabled">保存并继续添加</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/javascript">
    import selectMapMixin from 'mixins/selectMapMixin'
    import formCommonMixin from 'mixins/formCommonMixin'
    import pattern from 'modules/pattern'
    import dateOptionMixin from 'mixins/dateOptionMixin'
    import { dateFormat } from 'modules/tools'
    import { debouncing } from 'utils'

    const Model = {
        id: '',
        name: '',          // 职位名称
        workPlace: '',     // 办公地点
        sequenceMain: '',  // 岗位序列
        sequenceSub: '',   // 岗位子序列
        onlineDate: '',    // 上线时间
        offlineDate: '',   // 下线时间
        recruitCount: '',  // 人数
        state: '',         // 状态
        description: '',   // 职位描述
        requirement: '',   // 职位要求
        cityIds: [],       // 城市id
        property: '',
        advise: '',
        toSupplier: '0',
        showInDesk: '2',   // 是否门户展示
        recommendable: '0',       // 是否内推
        linkmanAndSupplier: [],
        mark: '',
        paymentId: '',
        deptCode: '',      // 招聘部门
        scoreType: '',     // 评分标准
        workType: ''       // 工作性质
    }
    export default {
        mixins: [selectMapMixin, formCommonMixin, dateOptionMixin],
        data () {
            return {
                urls: {
                    add: '/position/insert.api',
                    update: '/position/update.api',
                    fetch: '/position/selectByKey.api'
                },
                showDialog: false,
                isEdit: false,
                preventKey: 1,
                ruleForm: Object.assign({}, Model, {
                    mark: this.$store.state.user.name
                }),
                suppliers: [],
                filterEmpty: false,
                submitDisabled: false,
                rules: {
                    name: {required: true, message: '请输入', trigger: 'blur'},
                    recruitCount: [{pattern: /^([1-9]+[0-9]*]*|0)$/, message: '请输入整数', trigger: 'blur'}],
                    scoreType: {required: true, message: '请选择', trigger: 'change'},
                    description: {required: true, message: '请输入', trigger: 'blur'},
                    requirement: {required: true, message: '请输入', trigger: 'blur'},
                    mark: {required: true, message: '请输入', trigger: 'blur'},
                    workType: {required: true, message: '请输入', trigger: 'blur'},
                    cityIds: {type: 'array', required: true, message: '请选择', trigger: 'change'},
                    onlineDate: {type: 'date', required: true, message: '请选择', trigger: 'change'},
                    offlineDate: {type: 'date', required: true, message: '请选择', trigger: 'change'},
                    state: {required: true, message: '请选择', trigger: 'change'},
                    deptCode: {required: true, message: '请选择', trigger: 'change'},
                    sequenceMain: {required: true, message: '请选择', trigger: 'change'},
                    property: {required: true, message: '请选择', trigger: 'change'},
                    toSupplier: {required: true, message: '请选择', trigger: 'change'},
                    showInDesk: {required: true, message: '请选择', trigger: 'change'},
                    paymentId: {required: true, message: '请选择', trigger: 'change'},
                    recommendable: {required: true, message: '请选择', trigger: 'change'},
                    linkmanAndSupplier: {type: 'array', required: true, message: '请选择', trigger: 'change'},
                    sequenceSub: {required: true, message: '请选择', trigger: 'change'},
                    workPlace: {required: true, message: '请输入', trigger: 'blur'},
                },
                deptArr: [],
                paymentRuleList: []
            }
        },
        computed: {
            needIds () {
                return this.$store.state.needIds.needIds
            },
            projectId () {
                return this.$store.state.user.projectId.toString()
            },
            hasSalary () {
                return this.$store.state.user.paymentFlag
            },
            rangeStartDate () {
                return this.ruleForm.onlineDate
            },
            rangeEndDate () {
                return this.ruleForm.offlineDate
            },
            mainSeqList () {
                return this.selectMap.WB_POSITION_SEQUENCE_JSON || []
            },
            subSeqList () {
                const mainSeq = this.mainSeqList.find(({ value }) => this.ruleForm.sequenceMain === value) || {}
                return mainSeq.list || []
            }
        },
        watch: {
            'ruleForm.cityIds': function(nV) {
                if(!nV.length) {
                    this.ruleForm.linkmanAndSupplier = []
                }
                let citys = nV.join(',')
                this.$axios.get(`/supplierLinkman/listAllLinkman.api?citys=${citys}`).then(res => {
                    this.suppliers = (res.result.list || []).map(item => {
                        return {
                            compName: item[0].company,
                            compId: `sp${item[0].companyId}`,
                            users: item.map(user => {
                                return { ...user, visible: true }
                            }),
                            checkAll: false
                        }
                    })
                    const list = res.result.list || []
                    const flattenList = list.map(section => section.map(s => s.id + '')).flatten()
                    const compList = this.suppliers.map(s => s.compId)
                    const checkList = flattenList.concat(compList)

                    this.ruleForm.linkmanAndSupplier = this.ruleForm.linkmanAndSupplier.filter(id => checkList.includes(id))
                })
            }
        },
        created () {
            this.hasSalary && this.$axios.get('/payment/template/list.api?state=1&pageSize=100').then(res => {
                this.paymentRuleList = res.result.list
            })
        },
        methods: {
            show (data) {
                this.preventKey++
                this.ruleForm = Object.assign({}, Model, {
                    mark: this.$store.state.user.name
                })
                if (data) {
                    this.fetchData(data.id)
                }
                this.isEdit = Boolean(data && data.id)
                this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
                this.showDialog = true
            },
            checkStateOption (state) {
                if (this.isEdit === false) {
                    return state.value === '0' || state.value === '3'
                } else {
                    return true
                }
            },
            handleOptionChange(ids) {
                let values = ids.slice()

                this.suppliers.forEach(item => {
                    if(ids.includes(item.compId)) {
                        let userIds = item.users.map(u => u.id + '')
                        values = values.filter(l => !userIds.includes(l))
                    }
                })

                this.ruleForm.linkmanAndSupplier = values
            },
            selectFilter: debouncing(function(keyword) {
                let filterEmpty = true
                if(keyword) {
                    this.suppliers.forEach(item => {
                        item.users.forEach(user => {
                            user.visible = user.name.includes(keyword) || item.compName.includes(keyword)
                            if(filterEmpty && user.visible) {
                                filterEmpty = false
                            }
                        })
                    })
                } else {
                    this.suppliers.forEach(item => {
                        item.users.forEach(user => {
                            user.visible = true
                        })
                    })
                    filterEmpty = false
                }
                this.filterEmpty = filterEmpty
            }, 500),
            saveForm (boolean) {
                // 提交表单

                let supplierIds = [], linkmanIds = []

                if(this.ruleForm.toSupplier == '1') {
                    const allLinkmanList = this.suppliers.map(s => s.users.map(u => u.id + '')).flatten()
                    for(let item of this.ruleForm.linkmanAndSupplier) {
                        if(allLinkmanList.includes(item)) {
                            linkmanIds.push(item)
                        } else if(this.suppliers.map(s => s.compId).includes(item)) {
                            supplierIds.push(item.slice(2))
                        }
                    }
                }
                
                let postData = Object.assign({}, this.ruleForm, {
                    cityIds: this.ruleForm.cityIds.join(','),
                    onlineDate: dateFormat(this.ruleForm.onlineDate),
                    offlineDate: dateFormat(this.ruleForm.offlineDate),
                    supplierIds: supplierIds.join(','),
                    linkmanIds: linkmanIds.join(',')
                })

                delete postData.linkmanAndSupplier

                this.submitDisabled = true
                this.$axios.post(this.ruleForm.id ? this.urls.update : this.urls.add, postData, {'X-showMessage': true}).then(res => {
                    this.resetForm('ruleForm')
                    if (boolean === true) {
                        this.showDialog = false
                    }
                    this.$emit('reload')
                    this.submitDisabled = false
                }).catch(() => {
                    this.submitDisabled = false
                })
            },
            remoteMethod (query) {
                if (query !== '') {
                    this.$axios.get('/system/department/seachDep.api', {
                        params: {name: query}
                    }).then(res => {
                        this.deptArr = res.result.list
                    })
                } else {
                    this.deptArr = []
                }
            },
            fetchData (id) {
                let params = {
                    id,
                    notShowAllLinkMan: 1
                }
                this.$axios.get(this.urls.fetch, { params }).then(res => {
                    let data = res.result.bean
                    for (let attr in this.ruleForm) {
                        if (attr === 'cityIds') {
                            this.ruleForm[attr] = data['citys'].map(item => String(item.id))
                        } else if (attr === 'linkmanAndSupplier') {
                            let linkmanIds = data.linkmanIds && data.linkmanIds.split(',') || []
                            let supplierIds = (data.supplierIds && data.supplierIds.split(',') || []).map(s => `sp${s}`)
                            this.ruleForm[attr] = Array.from(new Set(linkmanIds.concat(supplierIds)))
                        } else if (attr === 'onlineDate' || attr === 'offlineDate') {
                            this.ruleForm[attr] = new Date(data[attr])
                        } else {
                            this.ruleForm[attr] = typeof data[attr] === 'number' ? data[attr] + '' : data[attr]
                        }
                    }
                    data.deptCode && (this.deptArr = [{deptCode: data.deptCode, name: data.deptNames}])
                })
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    .form-col .col-2 > .el-form-item{
        width: 49%;
        float: initial;
        display: inline-block;
    }
</style>

<style type="text/css" lang="scss">
    .supplier-checkbox {
        color: #8492a6;
        font-size: 12px;
        padding-left: 8px;
    }

    .supplier-select-popover.el-select-dropdown.is-multiple {
        .el-select-dropdown__item.is-disabled{
            color: rgb(191, 199, 217);
            background-color: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// addPositionDialog.vue?0a9435e0